import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { HeroOffice } from './HeroOffice';
import { HeroResto } from './HeroResto';
import { HeroNightclub } from './HeroNightclub';

export const ThemeAwareHero: React.FC = () => {
  const { theme } = useTheme();
  
  if (theme === 'nightclub') return <HeroNightclub />;
  if (theme === 'resto') return <HeroResto />;
  return <HeroOffice />;
};